export default __webpack_public_path__ + "static/media/segments.e7c2946b.svg";